import React from 'react';
import { Button, Switch, Space, Typography, Tooltip, Row } from 'antd';
import { SaveOutlined, FilePdfOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';

const Toolbar = ({ onExportPDF, editMode, toggleEditMode }) => {
  return (
    <Row justify={'space-between'} align={'middle'} className={'shadow-lg p-3'}>
      <Typography.Text strong>PDF Options</Typography.Text>
      <Space>
        <Tooltip title="Toggle Edit Mode">
          <Switch
            checkedChildren={<EditOutlined />}
            unCheckedChildren={<EyeOutlined />}
            checked={editMode}
            onChange={toggleEditMode}
          />
        </Tooltip>
        <Tooltip title="Export to PDF">
          <Button icon={<FilePdfOutlined />} onClick={onExportPDF}>
            Export to PDF
          </Button>
        </Tooltip>
      </Space>
    </Row>
  );
};

export default Toolbar;
